import styled from 'styled-components';
import { StyledTabs } from "../../../Tabs";
import { MediaBreakPointUp } from "../../../../theme";
export var StyledOrderListWrapper = styled.div.withConfig({
  displayName: "StyledOrderListWrapper",
  componentId: "sc-jfmzen-0"
})(["position:relative;display:flex;flex-flow:row wrap;justify-content:space-between;align-items:center;width:100%;margin:16px auto 0;padding:20px 24px;border-radius:16px;border:0.5px solid #e7e2ff;background:#ffffff;overflow:hidden;@media screen and (max-width:", "){width:calc(100% - 30px);box-sizing:border-box;margin-bottom:20px;}"], MediaBreakPointUp.sm);
export var StyledOrderList = styled.div.withConfig({
  displayName: "StyledOrderList",
  componentId: "sc-jfmzen-1"
})(["display:flex;flex-flow:row wrap;justify-content:flex-start;align-items:center;gap:32px 24px;overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;width:100%;max-height:510px;@media screen and (max-width:", "){max-height:720px;}"], MediaBreakPointUp.sm);
export var StyledOrder = styled.div.withConfig({
  displayName: "StyledOrder",
  componentId: "sc-jfmzen-2"
})(["box-sizing:border-box;width:360px;"]);
export var StyledTokens = styled.div.withConfig({
  displayName: "StyledTokens",
  componentId: "sc-jfmzen-3"
})(["color:#191c1e;display:flex;font-size:14px;font-weight:500;justify-content:space-between;line-height:140%;margin-bottom:8px;.arrow-right{margin:0 8px;}"]);
export var StyledTradingPairWrapper = styled.div.withConfig({
  displayName: "StyledTradingPairWrapper",
  componentId: "sc-jfmzen-4"
})(["display:flex;align-items:center;"]);
export var Row = styled.div.withConfig({
  displayName: "Row",
  componentId: "sc-jfmzen-5"
})(["display:flex;flex-direction:row;justify-content:space-between;margin-bottom:4px;width:100%;.label{color:#6f7390;font-size:12px;font-weight:400;letter-spacing:0.242667px;line-height:140%;}.value{color:#2c2842;font-size:12px;font-weight:400;line-height:140%;}"]);
export var StyledYield = styled.span.withConfig({
  displayName: "StyledYield",
  componentId: "sc-jfmzen-6"
})(["color:", ";font-size:12px;font-weight:700;line-height:140%;"], _ref => {
  var color = _ref.color;
  return color !== null && color !== void 0 ? color : '#2c2842';
});
export var OrderStatus = styled.div.withConfig({
  displayName: "OrderStatus",
  componentId: "sc-jfmzen-7"
})(["color:#8d93b5;font-size:12px;font-weight:400;line-height:140%;white-space:nowrap;&.pending,&.partialfilled{color:#6bc7a1;}&.insufficient{color:#e75b55;}"]);
export var OrderNote = styled.div.withConfig({
  displayName: "OrderNote",
  componentId: "sc-jfmzen-8"
})(["background:#fffae9;border:0.5px solid #f3e7c7;border-radius:12px;color:#928761;font-size:12px;font-weight:400;line-height:16px;margin-bottom:8px;padding:8px 12px;"]);
export var ButtonsWrapper = styled.div.withConfig({
  displayName: "ButtonsWrapper",
  componentId: "sc-jfmzen-9"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;gap:8px;width:100%;margin-top:8px;"]);
export var CancelButton = styled.button.withConfig({
  displayName: "CancelButton",
  componentId: "sc-jfmzen-10"
})(["box-sizing:border-box;background:transparent;border-radius:24px;border:0.5px solid #e75b55;cursor:pointer;color:#e75b55;font-size:12px;font-weight:500;line-height:34px;padding:0 20px;height:34px;"]);
export var DetailButton = styled.button.withConfig({
  displayName: "DetailButton",
  componentId: "sc-jfmzen-11"
})(["box-sizing:border-box;flex:1;background:transparent;border:0.5px solid #9598ab;border-radius:24px;color:", ";font-size:12px;font-weight:500;line-height:34px;padding:0 20px;height:34px;cursor:", ";"], _ref2 => {
  var disabled = _ref2.disabled;
  return disabled ? '#9C9FB4' : '#191c1e';
}, _ref3 => {
  var disabled = _ref3.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
export var StyledEmptyOrder = styled.div.withConfig({
  displayName: "StyledEmptyOrder",
  componentId: "sc-jfmzen-12"
})(["color:#e9e9e9;font-size:13px;font-weight:400;line-height:140%;margin:35px auto 28px;text-align:center;width:64px;.note{margin-top:8px;}"]);
export var OrderTabs = styled(StyledTabs).withConfig({
  displayName: "OrderTabs",
  componentId: "sc-jfmzen-13"
})(["box-sizing:border-box;width:100%;height:28px;margin-bottom:24px;background:#fff;"]);